
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" id="Layer_1" x="0" y="0" style="enable-background:new 0 0 1200 1200" version="1.1" viewBox="0 0 1200 1200"><path d="M1178.6 688.1V66.4c0-24.9-20.1-45-45-45H919.4v856.9c0 34.4 41.6 51.6 65.9 27.3L1161.7 729c10.8-10.8 16.9-25.5 16.9-40.9z" class="st0"/><path d="M919.4 21.4H511.9c-15.3 0-30.1 6.1-40.9 16.9L294.5 214.8c-24.3 24.3-7.1 65.9 27.3 65.9h597.6V21.4z" class="st1"/><path d="M688.1 1178.6H66.4c-24.9 0-45-20.1-45-45V919.3h856.9c34.4 0 51.6 41.6 27.3 65.9L729 1161.7c-10.8 10.8-25.5 16.9-40.9 16.9z" class="st2"/><path d="M21.4 919.4V511.9c0-15.3 6.1-30.1 16.9-40.9l176.5-176.5c24.3-24.3 65.9-7.1 65.9 27.3v597.6H21.4z" class="st3"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    